import type { AlertProps } from '@sola/ark-core/molecules/alert/alert.tsx';

/**
 * Shared cart-drawer constants and the alert shape, split out from
 * `cart-drawer.tsx` so consumers can reference them without pulling in the
 * drawer itself.
 *
 * `nav-bag.tsx` only needs the focus-target props, and `contexts/cart-drawer.tsx`
 * only needs the alert shape. While both imported from `cart-drawer.tsx`, those
 * two edges dragged the whole drawer subtree (cart items, birthday appeal,
 * mini gallery, `cart-sdk`) into the header chunk on every page.
 */
const cartDrawerFocusTargetAttribute = 'data-cart-drawer-focus-target';

export { cartDrawerFocusTargetAttribute };

/**
 * Marks the element that should regain focus when the drawer closes — normally
 * the header's cart button.
 */
export const cartDrawerFocusTargetProps = {
  [cartDrawerFocusTargetAttribute]: true,
} as const;

export interface CartDrawerAlert {
  message: AlertProps['message'];
  variant?: AlertProps['variant'];
  title?: AlertProps['title'];
}
